import { useTranslation } from 'react-i18next';
import { API_POST, DBRequest, useConfig } from '../../api/api';
import ExoForm from '../../components/exo/ExoForm';

export const NewProjectPreset = ({ projectId, onClose }) => {
  const config = useConfig();
  const { t } = useTranslation();

  function handleSaveAsPreset(data) {
    const reqData = { ...data, projectId };
    DBRequest({
      config,
      path: `project-presets`,
      method: API_POST(reqData),
      onResponse: onClose,
    });
  }

  const fields = [
    {
      label: t('Icon'),
      type: 'icon',
      key: 'icon',
    },
    {
      label: t('Title'),
      type: 'text',
      key: 'title',
    },
    {
      type: 'divider',
      key: 'divider1',
    },
    {
      label: t('Include Billable Positions'),
      type: 'checkbox',
      key: 'includeBillablePositions',
      initialValue: '1',
    },
    {
      label: t('Include Calculative Hourly Rates'),
      type: 'checkbox',
      key: 'includeWagePresets',
      initialValue: '1',
    },
  ];

  return (
    <ExoForm
      header={t('Save as preset')}
      fields={fields}
      onSubmit={handleSaveAsPreset}
    />
  );
};
